import { render, staticRenderFns } from "./SeguroDecesos.vue?vue&type=template&id=2033e95c&scoped=true&"
import script from "./SeguroDecesos.vue?vue&type=script&lang=js&"
export * from "./SeguroDecesos.vue?vue&type=script&lang=js&"
import style0 from "./SeguroDecesos.vue?vue&type=style&index=0&id=2033e95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2033e95c",
  null
  
)

export default component.exports